import styled from 'styled-components';

export const NavbarWrapper = styled.nav`
  background: ${({ theme }) => theme.light};
  border: 1px solid ${({ theme }) => theme.border};
  box-shadow: ${({ theme }) => theme.shadow};
  border-radius: 24px;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;

  .chakra-menu__menu-list.profile-menu {
    padding: 0;
    background: ${({ theme }) => theme.light};
    border: 1px solid ${({ theme }) => theme.border};
    box-shadow: ${({ theme }) => theme.shadow};
    border-radius: 18px;
    overflow: hidden;
  }

  .navbar-title-box {
    @media only screen and (max-width: 991px) {
      display: none;
    }
  }

  .navbar-title {
    color: ${({ theme }) => theme.dark};
    font-size: 1rem;
    font-weight: 800;
    line-height: 1.2;
  }

  .navbar-subtitle {
    color: ${({ theme }) => theme.text};
    font-size: 0.82rem;
    margin-top: 0.2rem;
  }

  .menu-toggle-btn {
    background: ${({ theme }) => theme.bg} !important;
    color: ${({ theme }) => theme.dark} !important;
    border-radius: 14px !important;
    width: 46px !important;
    min-width: 46px !important;
    height: 46px !important;
    border: 1px solid ${({ theme }) => theme.border} !important;

    &:hover {
      background: ${({ theme }) => theme.primary}14 !important;
      color: ${({ theme }) => theme.primary} !important;
    }

    &:focus-visible {
      box-shadow: none !important;
    }
  }

  .nav-action {
    position: relative;
    text-decoration: none;
    display: inline-flex;
  }

  .nav-action-icon {
    width: 46px;
    height: 46px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.bg};
    color: ${({ theme }) => theme.dark};
    border: 1px solid ${({ theme }) => theme.border};
    transition: 0.2s ease;
  }

  .nav-action:hover .nav-action-icon {
    background: ${({ theme }) => theme.primary}14;
    color: ${({ theme }) => theme.primary};
  }

  .nav-badge {
    position: absolute;
    top: -6px;
    inset-inline-end: -6px;
    min-width: 20px;
    height: 20px;
    padding-inline: 5px;
    border-radius: 999px;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.error};
    color: ${({ theme }) => theme.light};
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    border: 2px solid ${({ theme }) => theme.light};
  }

  .lang-btn {
    background: ${({ theme }) => theme.bg} !important;
    color: ${({ theme }) => theme.dark} !important;
    border: 1px solid ${({ theme }) => theme.border} !important;
    border-radius: 14px !important;
    height: 46px !important;
    min-width: 46px !important;
    padding-inline: 0.9rem !important;
    display: inline-flex !important;
    align-items: center;
    gap: 0.45rem;

    &:hover {
      background: ${({ theme }) => theme.primary}14 !important;
      color: ${({ theme }) => theme.primary} !important;
    }

    &:focus-visible {
      box-shadow: none !important;
    }
  }

  .lang-text {
    font-size: 0.82rem;
    font-weight: 700;

    @media only screen and (max-width: 640px) {
      display: none;
    }
  }

  .profile-btn {
    background: ${({ theme }) => theme.bg} !important;
    color: ${({ theme }) => theme.dark} !important;
    border: 1px solid ${({ theme }) => theme.border} !important;
    border-radius: 16px !important;
    padding: 0.45rem 0.75rem !important;
    height: auto !important;
    min-height: 46px !important;

    &:hover {
      background: ${({ theme }) => theme.primary}10 !important;
    }

    &:focus-visible {
      box-shadow: none !important;
    }
  }

  .profile-text-box {
    text-align: start;

    @media only screen and (max-width: 991px) {
      display: none;
    }
  }

  .profile-name {
    font-size: 0.9rem;
    font-weight: 700;
    color: ${({ theme }) => theme.dark};
    line-height: 1.2;
  }

  .profile-role {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.text};
    margin-top: 0.15rem;
    text-transform: capitalize;
  }

  .menu-user-name {
    color: ${({ theme }) => theme.dark};
    font-weight: 800;
    font-size: 0.95rem;
    line-height: 1.3;
  }

  .menu-user-role {
    color: ${({ theme }) => theme.secColor};
    font-size: 0.83rem;
    margin-top: 0.2rem;
    text-transform: capitalize;
  }

  .menu-link {
    color: ${({ theme }) => theme.dark};
    padding: 0.75rem 0.85rem;
    border-radius: 12px;
    text-decoration: none;
    transition: 0.2s ease;
    font-weight: 600;

    &:hover {
      background: ${({ theme }) => theme.bg};
      color: ${({ theme }) => theme.primary};
    }
  }

  .logout-btn {
    width: 100%;
    height: 44px;
    border-radius: 12px !important;
    background: ${({ theme }) => theme.primary} !important;
    color: ${({ theme }) => theme.light} !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-weight: 700;

    &:hover {
      background: ${({ theme }) => theme.dark} !important;
    }
  }

  @media only screen and (max-width: 640px) {
    padding: 0.85rem 1rem;
    border-radius: 18px;

    .profile-btn {
      padding-inline: 0.55rem !important;
    }
  }
`;